export function handleSubmitButtonState(button, action = "Submitting", showEllipsis = true) {
    const spinnerTemplate = document.getElementById('spinner-template');
    if (button && spinnerTemplate) {
        button.innerHTML = `<span class='flex items-center justify-center'>${spinnerTemplate.innerHTML}${action}${showEllipsis ? '...' : ''}</span>`;
        button.disabled = true;
    }
} 